import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rightArrow",
  "use": "rightArrow-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol viewBox=\"0 0 7 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rightArrow\">\n<path d=\"M1.63574 9.90906L5.63574 5.90906L1.63574 1.90906\" stroke=\"black\" stroke-opacity=\"0.6\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol